(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["old-influencer-product"] && !Shopify.designMode) return;
  try {
    
// No JavaScript functionality needed for this section

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["old-tl-select-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var Accordion = function(el, multiple) {
      this.el = el || {};
      this.multiple = multiple || false;
    
      // Get all .flink elements
      var links = this.el.querySelectorAll('.flink');
      
      // Add event listeners
      var self = this;
      links.forEach(function(link) {
        link.addEventListener('click', function(e) {
          self.dropdown.call(this, e, self.el, self.multiple);
        });
      });
    }
  
    Accordion.prototype.dropdown = function(e, accordionEl, multiple) {
      var clickedLink = this;
      var parentLi = clickedLink.parentElement;
      
      // If not multiple, close other accordion items first
      if (!multiple) {
        var allParents = accordionEl.querySelectorAll('li');
        
        allParents.forEach(function(parent) {
          if (parent !== parentLi) {
            parent.classList.remove('open');
          }
        });
      }
      
      // Toggle the 'open' class on the clicked parent li
      parentLi.classList.toggle('open');
    };
  
    var accordionElement = document.querySelector('.accordion');
    if (accordionElement) {
      var accordion = new Accordion(accordionElement, false);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["old-xt-protein-raise"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var Accordion = function(el, multiple) {
      this.el = el || {};
      this.multiple = multiple || false;
    
      // Get all .flink elements
      var links = this.el.querySelectorAll('.flink');
      
      // Add event listeners
      var self = this;
      links.forEach(function(link) {
        link.addEventListener('click', function(e) {
          self.dropdown.call(this, e, self.el, self.multiple);
        });
      });
    }
  
    Accordion.prototype.dropdown = function(e, accordionEl, multiple) {
      var clickedLink = this;
      var parentLi = clickedLink.parentElement;
      
      // If not multiple, close other accordion items first
      if (!multiple) {
        var allParents = accordionEl.querySelectorAll('li');
        
        allParents.forEach(function(parent) {
          if (parent !== parentLi) {
            parent.classList.remove('open');
          }
        });
      }
      
      // Toggle the 'open' class on the clicked parent li
      parentLi.classList.toggle('open');
    };
  
    var accordionElement = document.querySelector('.accordion');
    if (accordionElement) {
      var accordion = new Accordion(accordionElement, false);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-main-collection-product-grid"]) return;
  try {
    
  if (!customElements.get('sb-mb-two-col-grid')) {
    class SbMbTwoColGrid extends HTMLElement {
      constructor() {
        super();
        this.ROW_SIZE = 2;
        this.RESIZE_DEBOUNCE = 250;
      }
  
      connectedCallback() {
        try {
          this.productGrid = this.querySelector('#product-grid');
          
          if (!this.productGrid) {
            console.warn('[SbMbTwoColGrid] Product grid not found');
            return;
          }

          // Wait for product cards to be rendered
          this.waitForProductCards();
          
          // Set up resize listener with debouncing
          this.setupResizeListener();
        } catch (error) {
          console.error('[SbMbTwoColGrid] Initialization error:', error);
        }
      }

      /**
       * Wait for product cards to be rendered before calculating heights
       */
      waitForProductCards() {
        const checkInterval = setInterval(() => {
          const cards = this.productGrid.querySelectorAll('.sb-product-card');
          
          if (cards.length > 0) {
            clearInterval(checkInterval);
            this.setTitleHeights();
          }
        }, 25);

        // Timeout after 30 seconds
        setTimeout(() => {
          clearInterval(checkInterval);
        }, 30000);
      }

      /**
       * Set up resize listener with debouncing
       */
      setupResizeListener() {
        let resizeTimer;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
            this.setTitleHeights();
          }, this.RESIZE_DEBOUNCE);
        });
      }

      /**
       * Calculate and apply uniform title heights for product cards in each row
       * Uses batch read/write approach to minimize layout thrashing
       */
      setTitleHeights() {
        if (!this.productGrid) return;

        const cards = this.productGrid.querySelectorAll('.sb-product-card');
        
        if (cards.length === 0) return;

        // BATCH 1: Reset all heights (single write pass)
        cards.forEach(card => {
          card.style.removeProperty('--sb-product-card-title-height');
        });

        // BATCH 2: Measure all heights (single read pass)
        const measurements = [];
        
        for (let i = 0; i < cards.length; i += this.ROW_SIZE) {
          const rowCards = Array.from(cards).slice(i, i + this.ROW_SIZE);
          let maxHeight = 0;
          
          rowCards.forEach(card => {
            const title = card.querySelector('.sb-product-card__title');
            if (title) {
              const height = title.scrollHeight;
              if (height > maxHeight) {
                maxHeight = height;
              }
            }
          });
          
          measurements.push({ rowCards, maxHeight });
        }

        // BATCH 3: Apply all heights (single write pass)
        measurements.forEach(({ rowCards, maxHeight }) => {
          if (maxHeight > 0) {
            rowCards.forEach(card => {
              card.style.setProperty('--sb-product-card-title-height', `${maxHeight}px`);
            });
          }
        });
      }
    }
  
    customElements.define('sb-mb-two-col-grid', SbMbTwoColGrid);
  }

  } catch(e) { console.error(e); }
})();
})();
